import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const ExerciseDoneCheckIcon: React.FC<IconSvgProps> = ({ color = "#133C40", ...props }) => (
  <svg width="30" height="43" viewBox="0 0 30 43" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.25 27.5159C5.25769 30.1313 11.9792 36.2251 14.8038 39.6774C18.3346 43.9928 27.75 6.72359 27.75 2.4082"
      stroke={color}
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
)
